import { AlertCircle } from 'lucide-react'
import { useState } from 'react'

import { m } from '@/lib/paraglide/messages'
import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog'
import { MisaAccountCard } from '@/components/invoices/misa-account-card'

export function MisaCredentialNotice({
    invalidSince,
    invalidReason,
}: {
    invalidSince?: string | null
    invalidReason?: string | null
}) {
    const invalid = Boolean(invalidSince)
    const [open, setOpen] = useState(false)
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <div
                className={
                    invalid
                        ? 'space-y-2 rounded-md border border-destructive/40 bg-destructive/5 p-3'
                        : 'space-y-2 rounded-md border p-3'
                }
            >
                <div
                    className={
                        invalid
                            ? 'flex items-center gap-2 text-sm font-medium text-destructive'
                            : 'flex items-center gap-2 text-sm font-medium'
                    }
                >
                    <AlertCircle className="size-4" />
                    {invalid
                        ? m.einvoice_credential_blocked_title()
                        : m.einvoice_credential_missing_title()}
                </div>
                {!invalid ? (
                    <p className="text-xs text-muted-foreground">
                        {m.einvoice_credential_missing_hint()}
                    </p>
                ) : null}
                {invalid && invalidReason ? (
                    <p className="break-words text-xs text-destructive">
                        {invalidReason}
                    </p>
                ) : null}
                <div className="flex flex-wrap items-center gap-3">
                    <DialogTrigger asChild>
                        <Button type="button" size="sm">
                            {invalid
                                ? m.einvoice_credential_update_cta()
                                : m.einvoice_credential_connect_cta()}
                        </Button>
                    </DialogTrigger>
                </div>
                <DialogContent className="max-h-[calc(100dvh-2rem)] w-[calc(100vw-2rem)] overflow-y-auto sm:max-w-lg">
                    <DialogHeader>
                        <DialogTitle>
                            {invalid
                                ? m.einvoice_credential_update_title()
                                : m.einvoice_credential_connect_title()}
                        </DialogTitle>
                        <DialogDescription>
                            {m.einvoice_credential_dialog_desc()}
                        </DialogDescription>
                    </DialogHeader>
                    {open ? (
                        <MisaAccountCard
                            compact
                            onConnected={() => setOpen(false)}
                        />
                    ) : null}
                </DialogContent>
            </div>
        </Dialog>
    )
}
